module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Download-9f2175b16370d0ed65e615471db8193e.svg";